import { ICompPrice } from "features/Comp/interfaces";
import { apiClient } from "lib/apiClient";

export const getCompPrice = async (): Promise<ICompPrice> => {
  const response = await apiClient.get("/comps/price");

  return response.data;
};
